import React from "react"
import { Dropdown } from 'primereact/dropdown';
import CSServiceUtil from '../util/CSServiceUtil'
import CSBaseControl from "./CSBaseControl";
import CSRequestUtil from "../util/CSRequestUtil";
import { cfGetConstantValue } from "../util/CSConstantUtil";

class CSDropDown extends CSBaseControl {
    constructor(props) {
        super(props);

        this.state =
        {
            mDataProvider: [],
            mValue: (this.props.pValue) ? this.props.pValue : null,
            mPlaceHolder: this.props.pPlaceHolder
        }

        let lProperties = null;
        if (this.props.hasOwnProperty('cs_form_criteria_properties_')) {
            lProperties = this.props.cs_form_criteria_properties_;
        }
        else if (this.props.hasOwnProperty('cs_form_item_properties_')) {
            lProperties = this.props.cs_form_item_properties_;
        }

        if (lProperties) {
            for (let lInd = 0; lInd < lProperties.length; lInd++) {
                let lProperty = lProperties[lInd];
                if ((lProperty.type_ === 'other') && (lProperty.property_ === 'place_holder')) {
                    this.state.mPlaceHolder = lProperty.value_;
                    break;
                }
            }
        }

        this.mServiceUtil      = CSServiceUtil.cfGetInstance();
        this.cfGetControlLabel = this.cfGetControlLabel.bind(this);
        this.cfHandleChange    = this.cfHandleChange.bind(this);
        this.cfHandleResponse  = this.cfHandleResponse.bind(this);
        this.cfSetControlValue = this.cfSetControlValue.bind(this);
    }

    componentDidMount() {
        if (this.props.data_provider_source_) {
            if ((this.props.data_provider_source_ === '#COLLECTION#') && this.props.hasOwnProperty('mDataProvider')) {
                this.setState(
                    {
                        mDataProvider: this.props.mDataProvider,
                        mValue: this.cfSetControlValue(this.props.mDataProvider, this.props.pDataProviderId, this.props.mValue)
                    }
                );
            }
            else {
                this.mServiceUtil.cfGetDataFromDataProvider(this.props.data_provider_source_, this.cfHandleResponse);
            }
        }
    }

    componentDidUpdate(lPrevProps, lPrevState) {
        if (lPrevProps !== this.props) {
            if (lPrevProps.pShow !== this.props.pShow) {
                this.setState({
                    mValue: (this.props.pValue) ? this.props.pValue : null,
                });
            }

            if (this.props.data_provider_source_) {
                if ((this.props.data_provider_source_ === '#COLLECTION#') && this.props.hasOwnProperty('mDataProvider')) {
                    this.setState(
                        {
                            mDataProvider: this.props.mDataProvider,
                            mValue: this.cfSetControlValue(this.props.mDataProvider, this.props.pDataProviderId, this.props.mValue)
                        }
                    );
                }
                else {
                    if(this.props.pFormItem && this.props.pFormItem.hasOwnProperty('mCriteriaList') && this.props.pFormItem.mCriteriaList){
                        
                        const lDataProviderObject = this.mServiceUtil.mDataProviderObjectMap[this.props.data_provider_source_];
                        if (lDataProviderObject && lDataProviderObject.service_code_){
                            const lServiceObject = this.mServiceUtil.cfGetServiceObject(lDataProviderObject.service_code_);
                            if(lServiceObject){
                                const lCriteriaObj = this.props.pFormItem.mCriteriaList;
                                const lRequestUtil = new CSRequestUtil('GET', lDataProviderObject.service_code_, lServiceObject.type_, null, lServiceObject);
                                if((lDataProviderObject.param_name_) || lServiceObject.hasOwnProperty('cs_service_properties_') || lDataProviderObject.hasOwnProperty('cs_data_provider_properties_')){
                                    if(lDataProviderObject.param_name_){
                                        lCriteriaObj[lDataProviderObject.param_name_] = cfGetConstantValue(lDataProviderObject.param_value_);
                                    }
                                    else if(lServiceObject.hasOwnProperty('cs_service_properties_')){
                                        const lServiceProperties = lServiceObject.cs_service_properties_;
                                        for(let lInd=0; lInd<lServiceProperties.length; lInd++){
                                            if(lServiceProperties[lInd].type_ === 'criteria'){
                                                lCriteriaObj[lServiceProperties[lInd].property_] = lServiceProperties[lInd].value_;
                                            }
                                        }
                                    }

                                    if(lDataProviderObject.hasOwnProperty('cs_data_provider_properties_')) {
                                        for(let ldpInd=0; ldpInd<lDataProviderObject.cs_data_provider_properties_.length; ldpInd++) {
                                            let lProperty = lDataProviderObject.cs_data_provider_properties_[ldpInd];
                                            lCriteriaObj[lProperty.param_name_] = cfGetConstantValue(lProperty.param_value_);
                                        }    
                                    }
                                }

                                lRequestUtil.cfSetRequestCriteria(lCriteriaObj);
                                lRequestUtil.cfProcessRequest((lResponse, lCriteria)=>
                                    {
                                        if(lResponse && lResponse.collection_){
                                            this.cfHandleResponse(this.props.data_provider_source_, lResponse.collection_);
                                        }
                                    }
                                );
                            }
                        }
                    }
                    else {
                        this.mServiceUtil.cfGetDataFromDataProvider(this.props.data_provider_source_, (lDataProviderId, lCollection) => {
                            this.cfHandleResponse(lDataProviderId, lCollection);
                        });    
                    }
                }
            }
            else {
                this.setState({ mValue: this.props.mValue });
            }
        }
    }

    componentWillUnmount() {
        this.props = null;
    }

    cfHandleResponse(lDataProviderId, lCollection) {
        if (this.props && (lDataProviderId === this.props.data_provider_source_)) {
            let lValue           = this.props.mValue;
            let lDataProvider    = null;
            let lDependentValObj = null;
            let lDependencyFlag  = false;
            if (this.props.hasOwnProperty('cs_form_criteria_properties_')) {
                let lProperties = this.props.cs_form_criteria_properties_;
                for (let lfcpInd = 0; lfcpInd < lProperties.length; lfcpInd++) {
                    let lProperty = lProperties[lfcpInd];
                    if (lProperty.type_ === 'dependency') {
                        if (lProperty.value_ && lProperty.selection_property_ && lProperty.mDependentValue) {
                            if (!lDependentValObj) {
                                lDependentValObj = {}
                            }

                            lDependentValObj[lProperty.selection_property_] = lProperty.mDependentValue;
                        }

                        lDependencyFlag = true;
                    }
                }
            }

            if (this.props.dependent_field_) {
                if (lCollection) {
                    if(this.props.dependent_value_){
                        for (let ldpInd = 0; ldpInd < lCollection.length; ldpInd++) {
                            let ldpObj = lCollection[ldpInd];
                            let lDependentField = (this.props.reference_field_) ? this.props.reference_field_ : this.props.dependent_field_;
                            if (lDependentField) {
                                if (ldpObj[lDependentField] && (ldpObj[lDependentField] === this.props.dependent_value_)) {
                                    if (!lDataProvider) {
                                        lDataProvider = [];
                                    }
    
                                    lDataProvider.push(ldpObj);
                                }
                            }
                        }
                    }
                    else {
//                        lDataProvider = lCollection;
                    }
                }
            }
            else if (lCollection && lDependentValObj) {
                for (let ldpInd1 = 0; ldpInd1 < lCollection.length; ldpInd1++) {
                    let ldpObj1 = lCollection[ldpInd1];
                    let lKeys = Object.keys(lDependentValObj);
                    let lIncludeFlag = true;
                    for (let lKeyInd = 0; lKeyInd < lKeys.length; lKeyInd++) {
                        let lKey = lKeys[lKeyInd];
                        if (ldpObj1.hasOwnProperty(lKey)) {
                            if (ldpObj1[lKey] !== lDependentValObj[lKey]) {
                                lIncludeFlag = false;
                                break;
                            }
                        }
                    }

                    if (lIncludeFlag) {
                        if (!lDataProvider) {
                            lDataProvider = [];
                        }

                        lDataProvider.push(ldpObj1);
                    }
                }
            }
            else {
                if (!lDependencyFlag) {
                    lDataProvider = lCollection;
                    if (this.props.hasOwnProperty('pFormItem') && this.props.pFormItem && this.props.pFormItem.constant_ && !this.props.pValue) {
                        lValue = this.props.pFormItem.constant_;
                    }
                }
            }

            this.setState(
                {
                    mDataProvider: lDataProvider,
                    mValue: this.cfSetControlValue(lDataProvider, this.props.pDataProviderId, lValue)
                }
            );
        }
    }

    cfSetControlValue(lCollection, lDataProviderId, lValue) {
        let lRetValue = null;
        if (lCollection && lValue) {
            if (lDataProviderId) {
                for (let ind = 0; ind < lCollection.length; ind++) {
                    let lData = lCollection[ind]
                    if (lData[lDataProviderId] === lValue) {
                        lRetValue = lData;
                        break;
                    }
                }
            }
            else {
                lRetValue = lValue;
            }
        }

        return lRetValue;
    }

    cfHandleChange(event) {
        let lSelectedData = event.value;
        if (this.props.pProcessChange) {
            let lData = {};
            lData.control_type_ = 'combo_box';
            lData.data_field_   = this.props.pDataField;
            lData.id_           = this.props.pId;
            if (lSelectedData) {
                if (lData.data_field_ && lSelectedData.hasOwnProperty(this.props.pDataProviderId)) {
                    lData.selected_data_ = lSelectedData;
                    lData.value_ = lSelectedData[this.props.pDataProviderId];
                }
                else {
                    lData.value_ = lSelectedData;
                }
            }

            this.props.pProcessChange(lData);
        }
    }

    cfGetControlLabel() {
        let lCtlLabel = null;
        if (this.props.pDisplayField) {
            let lLabel = null;
            if (this.props.pRequired) {
                lLabel = <> {this.props.pDisplayField} <span style={{ color: 'red' }}>&nbsp;* </span> </>
            }
            else {
                lLabel = <> {this.props.pDisplayField} </>
            }

            lCtlLabel =
                <div style={{ padding: '0.25em' }}>
                    <label style=
                        {
                            {
                                display: 'block',
                                fontSize: '12.5px',
                                fontWeight: this.props.pType === 'section_total' ? 500 : 500,
                                width: (!this.props.pLabelWidth) ? '100px' : this.props.pLabelWidth,
                                textAlign: this.props.pType === 'section_total' ? 'right' : 'left'
                            }
                        }>
                        {lLabel}
                    </label>
                </div>
        }

        return lCtlLabel;
    }

    render() {
        let ctl = null;
        if (this.props.pControlType && (this.props.pControlType === 'combo_box')) {
            ctl = (
                <div className="cs-control field grid">
                    {super.cfGetControlLabel()}

                    <Dropdown
                        disabled    = { !(this.props.editable_ === '1') }
                        className   = "cs-drop-down"
                        id          = {this.props.pId}
                        filter      = {true}
                        inputId     = {this.props.pId}
                        editable    = {this.props.pEditable}
                        showClear   = {!this.props.pRequired}
                        appendTo    = {document.body}
                        placeholder = {this.state.mPlaceHolder}
                        name        = {this.props.pDataField}
                        onChange    = {this.cfHandleChange}
                        options     = {this.state.mDataProvider}
                        value       = {this.state.mValue}
                        optionLabel = {this.props.data_provider_display_field_} />
                </div>
            )
        }

        return ctl;
    }
}

export default CSDropDown;
